export default from "./SuperchartLegend";
